import React, { useCallback, useState } from "react";
import { Collapse } from "reactstrap";
import { WizardSumarryItem } from "./WizardSummaryItem";
import { CMRightPlacedChildren } from "./CMRightPlacedChildren";

export const FieldAppModule = React.memo(({ level = 0, ...rest }) => {
  const {
    bottomPlacedChildren,
    chainedChildren,
    connectedByTopBracketChildren,
    rightPlacedChildren,
    sameLayer,
    directlyConnected,
    setSideBarId,
  } = rest;
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = useCallback(() => setIsOpen((val) => !val), []);

  const hasChildren =
    bottomPlacedChildren?.length ||
    chainedChildren?.length ||
    connectedByTopBracketChildren?.length ||
    rightPlacedChildren?.length ||
    sameLayer?.length;

  const renderSummary = useCallback(
    (item) => (
      <FieldAppModule
        key={item.id}
        isTopology={true}
        {...item}
        level={level + 1}
        setSideBarId={setSideBarId}
      />
    ),
    [level, setSideBarId],
  );

  return (
    <>
      <WizardSumarryItem
        {...rest}
        isTopology
        title={rest.title}
        handleToggle={handleToggle}
        isOpen={isOpen}
        level={level}
        hasChildren={hasChildren}
      />
      <Collapse isOpen={isOpen} className="ps-3">
        {sameLayer?.map(renderSummary)}
        {rightPlacedChildren?.map(renderSummary)}
        {bottomPlacedChildren?.map(renderSummary)}
        {connectedByTopBracketChildren?.map(renderSummary)}
        {chainedChildren?.map(renderSummary)}
      </Collapse>
      {directlyConnected?.length &&
        directlyConnected.map((item) => (
          <CMRightPlacedChildren
            {...item}
            key={item.id}
            setSideBarId={setSideBarId}
          />
        ))}
    </>
  );
});
